import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router/index.js'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import "./assets/css/base_css.less";
// import E from 'wangeditor'
import moment from 'moment'
Vue.prototype.$moment = moment
import enums from './utils/enums' // 全局枚举管理
import Pagination from "./components/Pagination";
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.snow.css' // 工具栏样式（必须）
import 'quill/dist/quill.core.css'  // 核心样式（建议加上）
import 'quill/dist/quill.bubble.css' // 可选，气泡主题样式
Vue.use(VueQuillEditor)
// 导入v-charts插件
import VCharts from "v-charts";
import * as common from './utils/util' // 全局公共方法
Object.keys(common).forEach(key => {
	Vue.prototype[`$${key}`] = common[key]
})

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer);
Vue.use(VCharts);

Vue.config.productionTip = false
Vue.prototype.$enums = enums
let EmbedBlot = VueQuillEditor.Quill.import('blots/block/embed');
// Vue.prototype.$E = E
// window.E = E // wang富文本编辑器
class AudioBlot extends EmbedBlot {
	static create(value) {
		let node = super.create();
		node.setAttribute('src', value.url);   //设置audio的src属性
		node.setAttribute('controls', true);   //设置audio的controls，否则他将不会显示
		node.setAttribute('controlsList', 'nodownload');   //设置audio的下载功能为不能下载
		node.setAttribute('id', 'voice');     //设置一个id
		return node;
	}
}
AudioBlot.blotName = 'audio';
AudioBlot.tagName = 'audio';
VueQuillEditor.Quill.register(AudioBlot);
Vue.use(VueQuillEditor)
Vue.filter('formatAmount', function(value) {
  if (value === null || value === undefined || value === '') return ''
  
  let num = parseFloat(value)
  if (isNaN(num)) return value
  
  // 判断是否为整数
  if (Number.isInteger(num)) {
    // 整数：千分位格式化，不显示小数部分
    return num.toLocaleString('zh-CN')
  } else {
    // 小数：千分位格式化，保留2位小数，去除末尾的0
    let parts = num.toLocaleString('zh-CN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).split('.')
    
    // 处理小数部分，去除末尾的0
    let decimalPart = parts[1].replace(/0+$/, '')
    
    if (decimalPart === '') {
      return parts[0] // 如果没有小数部分，只返回整数部分
    } else {
      return parts[0] + '.' + decimalPart
    }
  }
})

Vue.use(Antd)
Vue.component('Pagination', Pagination)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
